import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, CalendarCheck, Sparkles, Phone } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { Button } from "../components/ui/button";
import { useBooking } from "../context/BookingContext";

export default function ToxDepositThankYou() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { openBooking } = useBooking();

  return (
    <div data-testid="tox-deposit-thankyou-page">
      <Seo
        title="Deposit Received — Thank You"
        description="Your appointment deposit is confirmed."
        path="/tox-deposit/thank-you"
        noindex
      />
      <PageHeader
        overline="Deposit received"
        title="Thank you — you're all set"
        subtitle="Your deposit is confirmed and reserved toward your visit."
      />

      <section className="pb-24">
        <div className="max-w-xl mx-auto px-6 space-y-6">
          <div className="bg-white rounded-[2rem] p-8 md:p-10 border border-slate-100 text-center" data-testid="thankyou-card">
            <div className="mx-auto mb-5 h-14 w-14 rounded-full bg-emerald-50 flex items-center justify-center">
              <CheckCircle2 className="h-8 w-8 text-emerald-500" strokeWidth={1.5} />
            </div>
            <h2 className="font-heading text-2xl text-ink font-light">Your $20 deposit is confirmed</h2>
            <p className="text-[#5C6664] leading-relaxed mt-3">
              We've got you reserved. This deposit is <strong className="text-ink">credited at your appointment</strong> and
              deducted from your total — nothing more to do right now.
            </p>
            {sessionId && (
              <p className="mt-4 text-xs text-[#8A9492]" data-testid="thankyou-reference">
                Reference: {sessionId.slice(-12)}
              </p>
            )}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                onClick={() => openBooking()}
                data-testid="thankyou-book-btn"
                className="iri-gradient text-ink rounded-full h-12 px-8 font-medium hover:scale-[1.02] transition-transform"
              >
                <CalendarCheck className="h-4 w-4 mr-2" /> Book your appointment
              </Button>
              <a href="tel:+15866908693" data-testid="thankyou-call-btn"
                className="inline-flex items-center justify-center gap-2 h-12 px-8 rounded-full border border-slate-200 text-ink text-sm font-medium hover:bg-stone transition-colors">
                <Phone className="h-4 w-4" /> Call the spa
              </a>
            </div>
          </div>

          <RewardsCta />
        </div>
      </section>
    </div>
  );
}

export function RewardsCta() {
  return (
    <div className="rounded-[2rem] p-7 md:p-8 bg-[#241f38] text-center" data-testid="rewards-cta">
      <div className="mx-auto mb-4 h-11 w-11 rounded-full iri-gradient flex items-center justify-center">
        <Sparkles className="h-6 w-6 text-ink" strokeWidth={1.5} />
      </div>
      <h3 className="font-heading text-xl md:text-2xl text-white font-light">
        Sign up for rewards and start earning VIP upgrades today
      </h3>
      <p className="text-[#cfc7ea] text-sm mt-2 leading-relaxed max-w-md mx-auto">
        It's free to join — earn points on every visit and turn them into complimentary treatments and members-only perks.
      </p>
      <Link to="/register" data-testid="rewards-cta-btn"
        className="mt-6 inline-flex items-center justify-center gap-2 h-12 px-8 rounded-full iri-gradient text-ink text-sm font-medium hover:scale-[1.02] transition-transform">
        Join rewards — free
      </Link>
    </div>
  );
}
